import React, { useState } from 'react'

import Button from '~/components/button'
import InjuryProtectionInfoModal from '~/components/injury-protection-info-modal'
import InsuranceInfoModal from '~/components/insurance-info-modal'
import { i18n } from '~/i18n'

type Props = {
  className?: string
  addonProduct: string
}

const ADDON_MAP = {
  insurance: InsuranceInfoModal,
  injury_protection: InjuryProtectionInfoModal,
}

export default function AddonInfoButton({ className, addonProduct }: Props) {
  const [modalOpen, setModalOpen] = useState(false)

  const Modal = ADDON_MAP[addonProduct]
  if (!Modal) return null

  return (
    <>
      <Button
        type="icon"
        glyph="circle-info"
        aria-label={i18n.t('pages.cart.pass_protection_info')}
        onClick={() => setModalOpen(true)}
        className={className}
      />
      {modalOpen && <Modal onClose={() => setModalOpen(false)} />}
    </>
  )
}
